import { useSelector } from "react-redux";
import { StoreState } from "../../../../redux/storeState/storeState";
import axios from "axios";
import { useEffect, useState } from "react";
import CustomUnderlineInput from "../../../../components/integration/Input";
import moment from "moment";

interface PosCertificateDetailsIProp {
  setSelectedOption: any;
  selectedOption: any;
}
function IntegrationCertificateDetails({ setSelectedOption, selectedOption }: PosCertificateDetailsIProp) {
  const [posForEdit, setposForEdit] = useState<any>([]);
  const { companyInfo } = useSelector((state: StoreState) => ({
    companyInfo: state.companies.companySideInfoData,
  }));

  let isPosLinked = posForEdit?.zatca?.certificateId?.length > 0;

  const fetchAllPos = async () => {
    if (companyInfo?.id) {
      let allPos = await axios.get(`/admin-company-pointOfSales/${companyInfo?.id}?skipPagination=${true}`);
      let refactoredPos = allPos?.data?.results?.map((item: any) => {
        return {
          ...item,
          id: item?.businessId,
          storeName: item?.store,
          status: item?.zatca?.certificateId?.length > 0 ? "Active" : "Inactive",
        };
      });
      let posId = selectedOption.split("_").pop();
      let selectedPos = refactoredPos.filter((item: any) => item?._id === posId);
      setposForEdit(selectedPos[0]);
    }
  };

  useEffect(() => {
    fetchAllPos();
    //eslint-disable-next-line
  }, []);

  let refactoredPosData = [
    {
      value: posForEdit?.name,
      label: "Device Name",
    },
    {
      value: posForEdit?.id,
      label: "Device ID",
    },
    {
      value: posForEdit?.status,
      label: "Status",
    },
    {
      value: "Fatoraty System v1.0",
      label: "Model",
    },
    {
      value: posForEdit?.storeName,
      label: "Store Name",
    },
    {
      value: posForEdit?.address ? posForEdit?.address : "",
      label: "Store Address",
    },
    {
      value: posForEdit?.crNumber,
      label: "CR Number",
    },
  ];
  const date = moment(posForEdit?.zatca?.expiresAt);
  const isAfterToday = date.isAfter(moment(), "day");
  let certificateData = [
    {
      value: isPosLinked ? posForEdit?.zatca?.certificateId : "",
      label: "CSID",
    },
    {
      value: isPosLinked ? (!posForEdit?.zatca?.useTestCsr ? "Production" : "Simulation") : "",
      label: "Type",
    },
    {
      value: isPosLinked ? moment(posForEdit?.zatca?.onboardedAt)?.format("DD MMM YYYY") : "",
      label: "Date",
    },
    {
      value:
        !posForEdit?.zatca?.isExpired && posForEdit?.zatca?.expiresAt
          ? `${moment(posForEdit?.zatca?.expiresAt)?.format("DD MMM YYYY")} ${isAfterToday ? "(5 years)" : ""} `
          : posForEdit?.zatca?.isExpired
            ? "Expired"
            : "",
      label: "Expires",
    },
  ];

  return (
    <div>
      <div className="main-overview-wrap">
        <div className="title-subscription">Companies &gt; {companyInfo?.businessName} &gt; Integration &gt; Zatca</div>
        <button
          className="back-btn"
          onClick={() => {
            setSelectedOption("integration_pos_details");
          }}
        >
          Back
        </button>
      </div>
      <div className="subscription-id">POS ID {posForEdit?.id}</div>

      <div className="mt-3">
        <div className=" mt-2 w-100 h-100">
          <div className="row" style={{ gap: ".5rem" }}>
            <div className="col-5 payment-card-wrap">
              <div className="title-text">
                <div className="zatca-heading-text pb-4">POS Details</div>
                <div>
                  {refactoredPosData?.map((item) => {
                    return (
                      <>
                        <CustomUnderlineInput
                          label={item?.label}
                          value={item?.value}
                          disabled
                          //   noValueStyle={item?.value?.length === 0 ? true : false}
                        />
                      </>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="col payment-card-wrap fit-content-height">
              <div className="zatca-heading-text pb-4">Certificate Details</div>
              <div>
                {certificateData?.map((item) => {
                  return (
                    <>
                      <CustomUnderlineInput label={item?.label} value={item?.value} disabled />
                    </>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IntegrationCertificateDetails;
